'use client';

import { HttpStatus } from '@diritto/common/utils/requester/httpStatus';
import { ErrorStatus401 } from 'ui-components/error/ErrorStatus401';
import { ErrorStatus404 } from 'ui-components/error/ErrorStatus404';
import { ErrorStatus500 } from 'ui-components/error/ErrorStatus500';

export const ErrorStatusView = ({ statusCode }: { statusCode?: number }) => {
  const View = (() => {
    switch (statusCode) {
      case HttpStatus.NOT_FOUND:
        return ErrorStatus404;
      case HttpStatus.UNAUTHORIZED:
        return ErrorStatus401;
      default:
        return ErrorStatus500;
    }
  })();

  return (
    <div className="flex items-center justify-center min-h-[80vh] px-4">
      <View />
    </div>
  );
};

export default ErrorStatusView;
